import React from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TournamentWinner } from "@nestcoinco/hyper-api-gateway-api-client";
import { useSetAtom } from "jotai";

import "./LatestWinItem.scss";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";
import { gameDetailsDrawerSlugAtom } from "../../../jotai/atoms/games";

function LastWinItem({
  index,
  indexOfItemInView,
  winner,
}: {
  index: number;
  indexOfItemInView: number;
  winner: TournamentWinner;
}) {
  const { t } = useTranslation("games");
  const isCurrentItem = index === indexOfItemInView;
  const { avatarUrl, username, tournament } = winner;
  const setDrawerSlug = useSetAtom(gameDetailsDrawerSlugAtom);

  return (
    <GhostButton
      className="allow-pointer-events winnersDataContainer"
      onClick={() => setDrawerSlug(tournament?.game.slug)}
      style={{
        top: isCurrentItem ? 0 : -100,
        bottom: isCurrentItem ? 0 : undefined,
      }}
    >
      <Image src={avatarUrl} alt="user" className="winnerAvatarImg" />
      <p className="winnerInfo">
        @{username} {t("played")}{" "}
        <span className="gameName">{tournament?.game.name}</span>
      </p>
    </GhostButton>
  );
}

export default LastWinItem;
